<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">All Tenants</span><br/>
      <span style="font-style: italic; font-size: 18px">this page provides an overview on all accounts in the system</span>
    </div>

    <div style="margin: 20px;" v-if="!loading">
      <div class="row" style="font-weight: bold; font-size: 18px;">
        <div class="col" style="border: 0"><b-form-input style="width: 150px" v-model="results_filter" placeholder="text search"/></div>
        <div @click="filter_by_status(null,null)" class="col" style="border: 1px solid grey;">{{items.length}} of {{items_full.length}}</div>
        <div>&nbsp;&nbsp;|</div>
        <div class="col" style="margin-left:15px; border: 1px solid grey;">Vehicles: {{vehicle_cnt}}</div>
        <div class="col" style="margin-left:15px; border: 1px solid grey;">Drivers: {{driver_cnt}}</div>
        <div>&nbsp;&nbsp;|</div>
        <div @click="filter_by_status('tenant', 'CM')" class="col" :style="selected_tenant_type=='CM' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">CM: {{cm_cnt}}</div>
        <div @click="filter_by_status('tenant', 'TBN')" class="col" :style="selected_tenant_type=='TBN' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">TBN: {{tbn_cnt}}</div>
        <div @click="filter_by_status('tenant', 'FASTTRAK')" class="col" :style="selected_tenant_type=='FASTTRAK' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">FASTTRAK: {{fasttrak_cnt}}</div>
        <div>&nbsp;&nbsp;|</div>
        <div @click="filter_by_status('telematics', 'SAMSARA')" class="col" :style="selected_telematics_type=='SAMSARA' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">SAMSARA: {{samsara_cnt}}</div>
        <div @click="filter_by_status('telematics', 'SAUCON')" class="col" :style="selected_telematics_type=='SAUCON' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">SAUCON: {{saucon_cnt}}</div>
        <div @click="filter_by_status('telematics', 'ZONAR')" class="col" :style="selected_telematics_type=='ZONAR' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">ZONAR: {{zonar_cnt}}</div>
        <div>&nbsp;&nbsp;|</div>
        <div @click="filter_by_status('feature', 'actuals')" class="col" :style="selected_feature=='actuals' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Actuals: {{actuals_cnt}}</div>
        <div @click="filter_by_status('feature', 'alerts')" class="col" :style="selected_feature=='alerts' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Alerts: {{alerts_cnt}}</div>
        <div @click="filter_by_status('feature', 'reports')" class="col" :style="selected_feature=='reports' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">Reports: {{reports_cnt}}</div>
        <div @click="filter_by_status('feature', 'vsm')" class="col" :style="selected_feature=='vsm' ? 'margin-left:15px; border: 2px solid red;' : 'margin-left:15px; border: 1px solid grey;'">VSM: {{vsm_cnt}}</div>
      </div>
    </div>

      <b-table :busy="loading" sticky-header="80vh" striped hover bordered :items="items" :fields="fields" responsive
             :current-page="currentPage"
             :per-page="perPage">

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

        <template slot="last_actuals_request_time" slot-scope="row">
          {{row.item.last_actuals_request_time | formatDateTime}}
        </template>

        <template slot="last_booking_update_time" slot-scope="row">
          {{row.item.last_booking_update_time | formatDateTime}}
        </template>

        <template slot="users" slot-scope="row">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
          <template v-if="user.role=='customer-admin'" v-for="user in row.item.users">
              <tr>
                <td width="100">{{user.first_name}} {{user.last_name}}</td>
                <td width="80">{{user.username}}</td>
                <td width="80">{{user.phone_number | prettyPhoneNumber}}</td>
                <td width="80">{{user.job_title}}</td>
              </tr>
          </template>
          </table>
        </template>

        <template slot="features" slot-scope="row">
          <table width="100%" cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td>Actuals</td>
                <td><span v-if="row.item.actuals_enabled">&#10003;</span></td>
              </tr>
              <tr>
                <td>Actuals Out</td>
                <td><span v-if="row.item.actuals_outbound_enabled">&#10003;</span></td>
              </tr>
              <tr>
                <td>Alerts</td>
                <td><span v-if="row.item.alerts_enabled">&#10003;</span></td>
              </tr>
              <tr>
                <td>Reports</td>
                <td><span v-if="row.item.views_reports_enabled">&#10003;</span></td>
              </tr>
              <tr>
                <td>VSM</td>
                <td><span v-if="row.item.vehicle_status_management_enabled">&#10003;</span></td>
              </tr>
              <tr>
                <td>#</td>
                <td><span v-if="row.item.aws_phone_number">{{row.item.aws_phone_number}}</span></td>
              </tr>
          </table>
        </template>

      <template slot="details" slot-scope="row">
        <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? '-' : '+' }}
        </b-button>&nbsp;
      </template>

      <template slot="row-details" slot-scope="row">
        <b-card style="text-align: left;">
          <div style='min: 1500px; display: flex; flex-wrap: wrap'>
            <pre style="padding: 10px; background-color: white; text-align: left">{{row.item}}</pre>
          </div>
        </b-card>
      </template>

    </b-table>

  </div>
</template>
<script>
import {delete_booking, delete_tenant, get_all_tenants_config, send_sos_request} from '../networking/apis'
    import {mapState} from "vuex";

    export default {
      name: 'tenant_manager',
      data() {
        return {
          items: [],
          items_full: [],
          summary: {},
          loading: true,
          results_filter: null,
          selected_tenant_type: null,
          selected_telematics_type: null,
          selected_feature: null,
          boolean_options: [
            { text: 'True', value: 'True' },
            { text: 'False', value: 'False' },
          ],
          totalRows: 1,
          currentPage: 1,
          perPage: 100,
          pages: [],
          fields: [
            { key: 'details', label: '', sortable: false, thStyle: { width: "20px" }},
            { key: 'tenant_id', sortable: true, thStyle: { width: "100px" }},
            { key: 'tenant_name', sortable: true, thStyle: { width: "100px" }},
            { key: 'tenant_type', label: 'Ops', sortable: true, thStyle: { width: "50px" }},
            { key: 'telematics_type', label: 'Telematics', sortable: true, thStyle: { width: "50px" }},
            { key: 'last_actuals_request_time', label: 'Last Actuals Push', sortable: true, thStyle: { width: "150px" }},
            { key: 'last_booking_update_time', label: 'Last Booking Update', sortable: true, thStyle: { width: "150px" }},
            { key: 'vehicle_count', label: 'Vehicles', sortable: true, thStyle: { width: "50px" }},
            { key: 'driver_count', label: 'Drivers', sortable: true, thStyle: { width: "50px" }},
            { key: 'features', sortable: true, thStyle: { width: "150px" }},
            { key: 'users', sortable: true, thStyle: { width: "350px" }},
          ]

        }
      },
      async created() {
        this.load_data()
      },
      methods: {
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_all_tenants_config()
            this.summary = data.summary
            this.items = data.results
            this.items_full = data.results
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }

          this.loading = false
        },
        filter_by_status(type, value) {
          if (type == null) {
            this.selected_tenant_type = null
            this.selected_telematics_type = null
            this.selected_feature = null
          }

          if (type == 'tenant') {
            if (this.selected_tenant_type == value)
              this.selected_tenant_type = null
            else
              this.selected_tenant_type = value
          }

          if (type == 'telematics') {
            if (this.selected_telematics_type == value)
              this.selected_telematics_type = null
            else
              this.selected_telematics_type = value
          }

          if (type == 'feature') {
            if (this.selected_feature == value)
              this.selected_feature = null
            else
              this.selected_feature = value
          }

          this.items = this.items_full

          console.log("filter: " + this.selected_tenant_type + ":" + this.selected_telematics_type + ":" + this.selected_feature);

          if (this.selected_tenant_type)
            this.items = this.items.filter(item => item.tenant_type == this.selected_tenant_type)

          if (this.selected_telematics_type)
            this.items = this.items.filter(item => item.telematics_type == this.selected_telematics_type)

          if (this.selected_feature) {
            if (this.selected_feature == 'actuals')
              this.items = this.items.filter(item => item.actuals_enabled)
            else if (this.selected_feature == 'actuals_outbound')
              this.items = this.items.filter(item => item.actuals_outbound_enabled)
            else if (this.selected_feature == 'alerts')
              this.items = this.items.filter(item => item.alerts_enabled)
            else if (this.selected_feature == 'reports')
              this.items = this.items.filter(item => item.views_reports_enabled)
            else if (this.selected_feature == 'vsm')
              this.items = this.items.filter(item => item.vehicle_status_management_enabled)
          }
        },
        filter_results() {
          this.items = this.items_full
          if (this.results_filter) {
            const val = this.results_filter
            this.items = this.items.filter(item => (this.contains(item.tenant_name, val) || this.contains(item.aws_phone_number, val)));
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        },
        // list_contains(records, field, val2) {
        //   for (let record in records) {
        //     console.log('user:' + record)
        //     if (record[field] != null) {
        //       return record[field].toLowerCase().indexOf(val2.toLowerCase()) != -1;
        //     }
        //   }
        //   return false;
        // }
      } ,
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
        vehicle_cnt() {
          this.veh_items = this.items.filter(item => item.vehicle_count)
          const totalScore = this.veh_items.reduce(function (a, b) {
            return { vehicle_count: Number(a.vehicle_count) + Number(b.vehicle_count) };
          });
          return totalScore.vehicle_count;
        },
        driver_cnt() {
          this.veh_items = this.items.filter(item => item.driver_count)
          const totalScore = this.veh_items.reduce(function (a, b) {
            return { driver_count: Number(a.driver_count) + Number(b.driver_count) };
          });
          return totalScore.driver_count;
        },
        fasttrak_cnt() {
          return this.items_full.filter(item => item.tenant_type == 'FASTTRAK').length
        },
        cm_cnt() {
          return this.items_full.filter(item => item.tenant_type == 'CM').length
        },
        tbn_cnt() {
          return this.items_full.filter(item => item.tenant_type == 'TBN').length
        },
        samsara_cnt() {
          return this.items_full.filter(item => item.telematics_type == 'SAMSARA').length
        },
        saucon_cnt() {
          return this.items_full.filter(item => item.telematics_type == 'SAUCON').length
        },
        zonar_cnt() {
          return this.items_full.filter(item => item.telematics_type == 'ZONAR').length
        },
        actuals_cnt() {
          return this.items_full.filter(item => item.actuals_enabled).length
        },
        actuals_outbound_cnt() {
          return this.items_full.filter(item => item.actuals_outbound_enabled).length
        },
        alerts_cnt() {
          return this.items_full.filter(item => item.alerts_enabled).length
        },
        reports_cnt() {
          return this.items_full.filter(item => item.views_reports_enabled).length
        },
        vsm_cnt() {
          return this.items_full.filter(item => item.vehicle_status_management_enabled).length
        },
      },
      watch: {
        results_filter() {
          this.filter_results()
        }
      }
    }
</script>
<style scoped>
td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 330px;
}
</style>

